import { Intersect, Object, Omit, Optional, Static, String } from '@sinclair/typebox';

import { StringEnumSchema } from '../../../utils';
import { PointOfSale } from '../../sas-domain/pos';
import { RequestHeaders } from '../headers';

export const AwardRequestHeaders = Intersect([
  Omit(RequestHeaders, ['accept-language']),
  Object({
    pos: StringEnumSchema(PointOfSale),
    language: Optional(String()),
    // Added for legacy login auth cookie support
    authorization: Optional(String()),
  }),
]);

export type AwardRequestHeaders = Static<typeof AwardRequestHeaders>;
